// Devloped by Craig Spence
// https://github.com/phenomnomnominal/angular-2-local-storage
// Code copied from master branch commit 47c3cb2f93717fa6eb9feb556003053ef8585fd0

import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { ILocalStorageServiceConfig } from './local-storage.config.interface';

@NgModule({
    providers: [
        LocalStorageService
    ]
})
export class LocalStorageModule {
    static withConfig(userConfig: ILocalStorageServiceConfig = {}): ModuleWithProviders<LocalStorageModule> {
        return {
            ngModule: LocalStorageModule,
            providers: [
                { provide: 'LOCAL_STORAGE_SERVICE_CONFIG', useValue: userConfig }
            ]
        };
    }
}
